<script>
export default {
  name: 'inject-editor-practice-js',
  render: function (createElement) {
    const that = this
    this.$loadScript(that.$g.URL.editormdJqueryMinJs).then(() => {
      return that.$loadScript(that.$g.URL.jqconsole)
    }).then(() => {
      return that.$loadScript(that.$g.URL.editormdMinJs)
    }).then(() => {
      return that.$loadScript(that.$g.URL.JsCppMin)
    }).then(() => {
      return that.$loadScript(that.$g.URL.skulptMin)
    }).then(() => {
      return that.$loadScript(that.$g.URL.skulptStdlib)
    }).then(() => {
      return that.$loadScript(that.$g.URL.acejs)
    }).then(() => {
      return that.$loadScript(that.$g.URL.aceThemeJs)
    }).then(() => {
      return that.$loadScript(that.$g.URL.acePythonModeJs)
    }).then(() => {
      return that.$loadScript(that.$g.URL.aceCppModeJs)
    }).then(() => {
      return that.$loadScript(that.$g.URL.aceJavaModeJs)
    }).then(() => {
      return that.$loadScript(that.$g.URL.acePascalModeJs)
    }).then(() => {
      return that.$loadScript(that.$g.URL.aceExtLanguageToolsJs)
    }).then(() => {
      return that.$loadScript(that.$g.URL.editorcollapseJs + '&uuid=' + that.$g.uuid())
    }).then(() => {
      return that.$loadScript(that.$g.URL.editorBubbleJs + '&uuid=' + that.$g.uuid())
    }).then(() => {
      // window['Sk'].python3 = true
      this.$emit('injectJSFinish', true)
    })
      .catch((err) => {
      // Failed to fetch script
        console.log(err)
      })
    return createElement('div', [])
  }
}
</script>